import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles.css';
// Storm Watch's weather system. Every rule is scoped to .storm, which only
// exists while that theme is active.
import './themes/storm.css';
import 'devicon/devicon.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { resolveThemeId } from './themeConfig';

// Painted before React mounts so the first frame is already themed. Resolved
// against the current theme list, since a retired id no longer has any CSS.
const savedTheme = resolveThemeId(localStorage.getItem('selectedTheme'));
document.documentElement.setAttribute('data-theme', savedTheme);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
